<template>
    <div class="case" v-if="$root.dataReady">
        <header class="page-heading">
            <div class="container">
                <div class="text" v-html="post.content.rendered"></div>
                <div class="hero-caption"><em>{{ hero_caption }}</em></div>
            </div>
        </header>
        <div class="main-content">
            <template>
                <template v-for="(block, index) in blocks">
                    <component
                        :is="block.acf_fc_layout"
                        :key="index"
                        :blockdata="block"
                        :slug="slug"
                        :post_id="post_id"
                    ></component>
                </template>
            </template>

            <div class="bottom-button">
                <router-link tag="a" class="btn default" :to="{path: '/'+ slug}" v-html="button"></router-link>
            </div>
        </div>
    </div>
</template>

<script>
import Block from "../components/Block.vue";
import ImageWrapper from "../components/ImageWrapper";
import VideoWrapper from "../components/VideoWrapper";
import CaseFooter from "../components/CaseFooter";
import OurWorkSlider from "../components/OurWorkSlider.vue";
import BlockCmgGreenhouse from "../components/BlockCmgGreenhouse.vue";

export default {
    name: "case-page",
    props: ["slug"],
    data() {
        return {
            post: null,
            blocks: null,
            button: null,
            post_id: null,
            hero_caption: null,
        };
    },
    components: {
        ImageWrapper,
        Block,
        CaseFooter,
        VideoWrapper,
        OurWorkSlider,
        BlockCmgGreenhouse
    },
    created: function() {
        this.$root.headeriswhite = false;
        this.$root.dataReady = false;
    },
    mounted: function() {
        this.fetchData();
    },
    methods: {
        fetchData: function() {
            var self = this;
            $.get(
                self.$root.apiUrl +
                    "wp-json/wp/v2/cases_studies?slug=" +
                    self.$route.params.name,
                function(response) {
                    if (!response[0]) {
                        self.$router.push({ name: "page-not-found" });
                    } else {
                        self.post = response[0];
                        self.blocks = response[0].acf.block_grid;
                        self.button = response[0].acf.button_show_more_label;
                        self.setTitle(response[0].title.rendered);
                        self.$root.dataReady = true;
                        self.post_id = response[0].id;
                        self.hero_caption = response[0].acf.hero_caption;
                    }
                }
            )
                .done(function() {})
                .fail(function() {});
        },
        setTitle: function(title) {
            title = title.normalize('NFD').replace("&#038;", "&");
            document.title = title + " - Weber Shandwick";
        }
    }
};
</script>



// WEBPACK FOOTER //
// Case.vue?86885eb2